export const COLORS = {
  mainColor: '#0F425A',
  mainColor_op3: '#0f425a4d',
  mainColor_op7: '#0f425ab3',
  darkMainColor: '#081329',
  darkGray: '#C4C4C4',
  ultralightGray: '#F6F7FA',
  lightGray: '#E9EDF1',
  blue: '#065490',
  white: '#FFFFFF',
  whiteShadow: '#F8F8F8',
  whiteLite: '#f3f3f3',
  red: '#F20D0D',
  yellow: '#FFCC00',
  darkYellow: '#EDF1E9',
  multiGray: '#F8F8F8',
  multiGray_op9: '#F8F8F890',
  green: '#2EEA6E',
  black: '#303030',
  blackWithOpacity: '#30303040',
  overlay: '#313131cc',
  lightSilver: '#686868',
  multiSilver: '#686868e6',
  silverShadow: '#ebebeb',
};
